import CheckNull from "../../UserManagment/SubUserManagment/CheckNull";

function InfoUser({ user, close }) {

    const handleClose = () => {
        close(false);
    };

    return (
        <>
            <div className="modal-overlay fixed top-0 left-0 w-screen h-screen bg-black opacity-40" onClick={handleClose}></div>
            <div className="fixed top-[48%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg px-20 py-14 ">
                <img src="/image/icon/close.png" className="w-5" onClick={() => close(false)} />
                <p className="text-right text-lg font-bold mb-4">جزئیات کاربر</p>
                <div className="text-right flex flex-row-reverse">
                    <div className="w-40 text-slate-400">
                        <p className="mb-2">: نام</p>
                        <p className="mb-2">: نام خانوادگی</p>
                        <p className="mb-2">: نام کاربری</p>
                        <p className="mb-2">: موبایل</p>
                    </div>
                    <div>
                        <CheckNull item={user.name} />
                        <CheckNull item={user.family} />
                        <CheckNull item={user.userName} />
                        <CheckNull item={user.mobile} />
                    </div>
                </div>
            </div>
        </>
    );
}
export default InfoUser;
